import { Navigate, useParams } from 'react-router-dom';
import { useRouter } from 'hooks';
import { useTransientStore } from 'store';

/**
 * Redirect for unknown /community/:communityId/* paths.
 * Uses absolute paths to avoid relative "home" stacking (e.g. .../select-email/home/home/...).
 * When not logged in, sends user to the request-to-join flow (select-email).
 */
export const CommunityFallbackRedirect = () => {
	const router = useRouter();
	const { communityId } = useParams() as { communityId: string };
	const store = useTransientStore();

	const to = store.auth.isLoggedIn
		? router.getPathFor('community.home', { communityId })
		: router.getPathFor('request.root', { communityId });

	return <Navigate to={to} replace />;
};
